export default {
  product_list: null,
  isProductLoading: false,
  edit_product: null,
  isAddProductFormOpened:false,
  selected_product: null,
  school_guided_path_product: null,
  product_result: null
};
